export const printReceipt = (data) => {
  const printContent = `
  <div style="width: 50%; margin: 0 auto;" >
    <div><img display:none; src=https://www.cancer.org.br/wp-content/uploads/2020/08/logo_fundacao-e1553698988600-1.png></div>
    <br>
    <br>
    <br>
    <h4><b> RECIBO DE DOAÇÃO </b></h4>
  </div>
  <p> Prezado doador ${data.donator_name}, </p>
  <p> obrigado pela sua colaboracao no valor de ${data.mount_total} feita no dia ${data.created_at} atraves do ${data.payment_form}. </p>
  <p> As doações de pessoa física à Fundação do Câncer não são passíveis de dedução de imposto de renda. </p>`;
  document.getElementById('print-content').innerHTML = printContent;
  window.print();
};
